// extracted by mini-css-extract-plugin
export var center = "_48-2";
export var clickableRow = "_48-5";
export var expandedRow = "_48-7";
export var hoverable = "_48-4";
export var left = "_48-1";
export var right = "_48-3";
export var row = "_48-0";
export var selectedRow = "_48-6";
export var summaryRow = "_48-8";